<!-- web环境使用Teleport挂载到原生tabbar上 非web环境使用自定义tabbar -->
<template>
  <!-- custom-style="min-height: 100%" -->
  <wd-config-provider
    :custom-class="isDark ? `${themeClass} dark-mode page-wraper` : `${themeClass} page-wraper`"
    :theme-vars="themeVars"
    :theme="theme"
  >
    <!-- <view class="absolute z-10000 right-0">
      <view class="inline-flex items-center">
        <wd-switch v-model="isDark" @change="handleChange" />
      </view>
    </view> -->

    <!-- <wd-navbar
      :title="activeTabbar.title"
      safe-area-inset-top
      placeholder
      fixed
      :bordered="false"
    /> -->
    <slot />
    <!-- 自定义tabbr -->
    <!-- Web 环境下渲染 -->

    <template v-if="el && !hasTabbar">
      <Teleport defer to="uni-tabbar">
        <view id="wat-tabbar" :class="isDark ? `${themeClass} dark-mode` : `${themeClass}`">
          <WatTabbar />
        </view>
      </Teleport>
    </template>
    <!-- <template v-else>
      <view id="wat-tabbar">
        <WatTabbar  />
      </view>
    </template> -->






    <!-- 填充tabbar高度 -->
    <WatTabbarGap />
    <wd-notify />
    <wd-toast />
    <global-toast />
    <wd-message-box />
    <global-dialog />
    <!-- <privacy-popup /> -->
  </wd-config-provider>
</template>

<script lang="ts" setup>
import WatTabbar from '@/components/wat-tabbar/WatTabbar.vue'
import GlobalToast from '@/components/GlobalToast.vue'
import GlobalDialog from '@/components/GlobalDialog.vue'

// 注意 使用pinia可以 watch不行

const el = ref(false)
const hasTabbar = document.querySelector('#wat-tabbar') //  判断是否有挂载过tabbar


const { currentModule } = useTabbar()
const { theme, themeVars, switchTheme, toggleTheme } = useTheme()
const isDark = ref(theme.value === 'dark')

watchEffect(() => {
  switchTheme(currentModule.value)
})
const themeClass = computed(() => {
  switch (currentModule.value) {
    case 'rentalManage':
      return 'rental-theme'
    default:
      return 'mall-theme'
  }
})
const handleChange = () => {
  toggleTheme()
}
watch(
  () => theme.value,
  () => {
    isDark.value = theme.value === 'dark'
  },
)

// const instance = getCurrentInstance()
onShow(() => {



  // console.log('proxy', proxy)
  // let curRoute = proxy.$.$pageInstance.ctx.route // 此处不能用getCurrentPages()，极端情况会获取不到路由
  // console.log('instance layout=>', instance)
  // const pages = getCurrentPages()
  // console.log('uniapp页面栈pages=>', pages)
  // console.log('vue当前路由curRoute=>', curRoute)
  // console.log('vue实例instance=>', instance)
  // commonStore.setCommonData('curTabbarRoute', curRoute)
  // commonStore.setCommonData('isUpdateTabbar', false)


  // 判断是否有挂载tabbar的目标元素
  const targetElement = document.querySelector('.uni-tabbar-bottom')
  el.value = targetElement !== null

  // 移除原生tabbar
  const element = document.querySelector('.uni-tabbar')
  if (element) {
    element.remove() // 移除目标元素
  }

})

const tabbarRef = ref<HTMLElement | null>(null)
const height = ref(50)
onMounted(() => {
  nextTick(() => {
    // 获取 DOM 元素
    setTimeout(() => {
      const el = (tabbarRef.value as any)?.$el || tabbarRef.value
      if (el) {
        height.value = el.offsetHeight
      }
    }, 100)
  })
})
</script>
<script lang="ts">
export default {
  options: {
    addGlobalClass: true,
    virtualHost: true,
    styleIsolation: 'shared',
  },
}
</script>

<style lang="scss" scoped>
.page-wraper {
  box-sizing: border-box;
  min-height: calc(100vh - var(--window-top) - var(--tab-bar-height));
  background: #f7f8fa;
}

.dark-mode.page-wraper {
  background: #222;
}
</style>
